// extracted by mini-css-extract-plugin
module.exports = {"delta-prop-ultra-header":"Header_delta-prop-ultra-header__pDCey"};